import { ScaffolderPage } from '@backstage/plugin-scaffolder';
import { CustomTemplateCard } from './custom-template-card';
import { SCAFFOLDER_PAGE_HEADER_OPTIONS } from './constants';
import { ScaffolderGroupTitleMachX } from './scaffolder-group-title-machx';
import { ScaffolderGroupTitleGcpDataPlatform } from './scaffolder-group-title-gcp-data-platform';

type ScaffolderFieldExtensionsProps = {
  category?: string;
};

export const ScaffolderPageForCategory = ({
  category,
}: Readonly<ScaffolderFieldExtensionsProps>) => {
  return (
    <ScaffolderPage
      headerOptions={SCAFFOLDER_PAGE_HEADER_OPTIONS}
      templateFilter={
        category
          ? entity =>
              entity?.spec?.lifecycle !== 'experimental' &&
              entity?.spec?.type === category
          : entity => entity?.spec?.lifecycle !== 'experimental'
      }
      groups={[
        {
          title: <ScaffolderGroupTitleMachX />,
          filter: entity => entity?.metadata?.tags?.includes('machx') ?? false,
        },
        {
          title: <ScaffolderGroupTitleGcpDataPlatform />,
          filter: entity =>
            entity?.metadata?.tags?.includes('gcp-data-platform') ?? false,
        },
        {
          title: 'Create & Onboard',
          filter: () => true,
        },
      ]}
      components={{ TemplateCardComponent: CustomTemplateCard }}
    />
  );
};
